import React from 'react'
import * as bs4 from 'reactstrap'
import 'bootstrap/dist/css/bootstrap.min.css';
import Navbar from '../Navbar'
import { ScaleLoader } from 'react-spinners';
import ReactTooltip from 'react-tooltip'
import Select from 'react-select';
import Workbook from 'react-excel-workbook'
import moment from 'moment';
import ReactGA from 'react-ga';
const { proxy } = require('../../ip_api.config')

class Flim_PreviewItem extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            previewItem: '',
            onPage: 'Preview',
            arr_temp_edit: [],
            itemID: '',
            description: '',
            itemG3: '',
            ibrand3: '',
            value_serach: ''
        }
    }

    componentDidMount() {
        ReactGA.initialize('UA-176717650-5');
        ReactGA.pageview('/flim/PreviewItem');

        if (localStorage.getItem("ID_User") !== null) {
            this.getItem_Preview()
        } else {
            this.props.history.push({
                pathname: '/'
            })
        }
    }

    getItem_Preview = () => {
        this.setState({ isLoading: true, onPage: 'Preview' })
        let arroption_itemID = []
        let arroption_description = []
        let arroption_itemG3 = []
        let arroption_ibrand3 = []
        let url = proxy.server + '/flim/get_Viewitem'

        let dataWhere = {
            itemID: '',
            description: '',
            itemG3: '',
            ibrand3: '',
        }

        fetch(url, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json;charset=utf-8"
            },
            body: JSON.stringify({
                id: '',
                dataWhere: dataWhere
            })
        })
            .then(response => response.json())
            .then(async (responseJson) => {
                // console.log("responseJson", responseJson.result)
                responseJson.result.map(function (val, i) {
                    arroption_itemID.push(
                        { value: val.ItemId, label: val.ItemId }
                    )
                    arroption_description.push(
                        { value: val.EcoResProductTranslation_Name, label: val.EcoResProductTranslation_Name }
                    )
                    arroption_itemG3.push(
                        { value: val.ECL_ItemCategoryIdG3, label: val.ECL_ItemCategoryIdG3 }
                    )
                    arroption_ibrand3.push(
                        { value: val.ECL_ItemCategoryIdBrand3, label: val.ECL_ItemCategoryIdBrand3 }
                    )
                }, this)

                let newArray_itemID = await this.setUniqueArray(arroption_itemID)
                let newArray_description = await this.setUniqueArray(arroption_description)
                let newArray_itemG3 = await this.setUniqueArray(arroption_itemG3)
                let newArray_ibrand3 = await this.setUniqueArray(arroption_ibrand3)

                this.setState({
                    option_itemID: newArray_itemID,
                    option_description: newArray_description,
                    option_itemG3: newArray_itemG3,
                    option_ibrand3: newArray_ibrand3
                }, () => {
                    this.previewItem()
                })
            })
    }

    setUniqueArray = async (arroption) => new Promise((resolve, reject) => {
        let newArray = [];
        let uniqueObject = {};

        for (let i in arroption) {
            let objTitle = arroption[i]['value'];
            uniqueObject[objTitle] = arroption[i];
        }

        for (let i in uniqueObject) {
            newArray.push(uniqueObject[i]);
        }
        resolve(newArray)
    })

    allData_Preveiw = () => {
        window.location.reload()
    }

    previewItem = () => {
        this.setState({ isLoading: true, onPage: 'Preview' })

        const { itemID, description, itemG3, ibrand3 } = this.state
        let arr = []
        let dataWhere = {
            itemID: itemID,
            description: description,
            itemG3: itemG3,
            ibrand3: ibrand3,
        }

        let url = proxy.server + '/flim/get_Viewitem'
        fetch(url, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json;charset=utf-8"
            },
            body: JSON.stringify({
                id: this.state.value_serach,
                dataWhere: dataWhere
            })
        })
            .then(response => response.json())
            .then((responseJson) => {
                console.log('responseJson', responseJson)
                responseJson.result.map(function (val, i) {
                    arr.push(
                        <tr key={val.ItemId + val.db_name}>
                            <td>{this.state.value_serach !== 'IMPORTED' && <bs4.Button color="danger" size='sm' style={{ fontSize: 14 }} onClick={() => this.Delete_item(val.id)}>DEL</bs4.Button>}</td>
                            {
                                val.db_name === 'DPL' ?
                                    <td style={{ backgroundColor: '#00BFFF', color: '#000' }}>{val.db_name}</td>
                                    : val.db_name === 'DFIX' ?
                                        <td style={{ backgroundColor: '#00FA9A', color: '#000' }}>{val.db_name}</td>
                                        : val.db_name === 'DPT' ?
                                            <td style={{ backgroundColor: '#fec23e', color: '#000' }}>{val.db_name}</td>
                                            : ''
                            }
                            <td>{val.EcoResProductTranslation_LanguageId}</td>
                            <td>{val.ItemId}</td>
                            <td>{val.DisplayProductNumber}</td>
                            <td>{val.EcoResProductTranslation_Name}</td>
                            <td>{val.EcoResProductTranslation_Description}</td>
                            <td>{val.SearchName}</td>
                            <td>{val.NameAlias}</td>
                            <td>{val.DefaultOrderType}</td>
                            <td>{val.ProductType}</td>
                            <td>{val.ProductSubType}</td>
                            <td>{val.EcoResStorageDimensionGroup_Name}</td>
                            <td>{val.EcoResTrackingDimensionGroup_Name}</td>
                            <td>{val.ModelGroupId}</td>
                            <td>{val.ItemGroupId}</td>
                            <td>{val.CostGroupId}</td>
                            <td>{val.ReqGroupId}</td>
                            <td>{val.SerialNumGroupId}</td>
                            <td>{val.InventTableModuleInvent_UnitId}</td>
                            <td>{val.InventTableModuleInvent_PriceUnit}</td>
                            <td>{val.InventTableModuleInvent_PriceQty}</td>
                            <td>{val.CostModel}</td>
                            <td>{val.grossWidth}</td>
                            <td>{val.grossHeight}</td>
                            <td>{val.InventTableModulePurch_UnitId}</td>
                            <td>{val.InventTableModulePurch_PriceUnit}</td>
                            <td>{val.InventTableModulePurch_PriceQty}</td>
                            <td>{val.PurchModel}</td>
                            <td>{val.InventTableModulePurch_OverDeliveryPct}</td>
                            <td>{val.InventTableModulePurch_UnderDeliveryPct}</td>
                            <td>{val.ItemBuyerGroupId}</td>
                            <td>{val.InventTableModulePurch_TaxItemGroupId}</td>
                            <td>{val.InventTableModuleSales_UnitId}</td>
                            <td>{val.InventTableModuleSales_PriceUnit}</td>
                            <td>{val.InventTableModuleSales_PriceQty}</td>
                            <td>{val.InventTableModuleSales_TaxItemGroupId}</td>
                            <td>{val.InventTableModuleSales_LineDisc}</td>
                            <td>{val.ECL_NumberSequenceGroupProd}</td>
                            <td>{val.BOMUnitId}</td>
                            <td>{val.BOMCalcGroupId}</td>
                            <td>{val.DefaultDimension}</td>
                            <td>{val.PdsVendorCheckItem}</td>
                            <td>{val.InventSiteId}</td>
                            <td>{val.PurchInventLocationId}</td>
                            <td>{val.ItemInventLocationId}</td>
                            <td>{val.SalesInventLocationId}</td>
                            <td>{val.ECL_ItemCategoryIdG1}</td>
                            <td>{val.ECL_ItemCategoryIdG2}</td>
                            <td>{val.ECL_ItemCategoryIdG3}</td>
                            <td>{val.ECL_ItemCategoryIdG4}</td>
                            <td>{val.ECL_ItemCategoryIdBrand1}</td>
                            <td>{val.ECL_ItemCategoryIdBrand2}</td>
                            <td>{val.ECL_ItemCategoryIdBrand3}</td>
                            <td>{val.ECL_ItemCategoryIdBrand4}</td>
                            <td>{val.DPL_StatusItem}</td>
                        </tr>
                    )
                }, this)
                this.setState({
                    arr_save: responseJson.result, previewItem: arr, isLoading: false,
                    arrDataExcel: responseJson.result, filename: 'Item' + moment().format('YYYYMMDD')
                })
            })
    }

    getItem_Edit = () => {
        this.setState({ isLoading: true, onPage: 'Edit' })

        const { itemID, description, itemG3, ibrand3 } = this.state
        let arr = []
        let dataWhere = {
            itemID: itemID,
            description: description,
            itemG3: itemG3,
            ibrand3: ibrand3,
        }

        let url = proxy.server + '/flim/get_Viewitem'
        fetch(url, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json;charset=utf-8"
            },
            body: JSON.stringify({
                id: '',
                dataWhere: dataWhere
            })
        })
            .then(response => response.json())
            .then((responseJson) => {
                console.log("responseJson", responseJson.result)
                responseJson.result.map(function (val, i) {
                    arr.push(
                        <tr key={val.ItemId + val.db_name}>
                            <td style={{ justifyContent: 'center' }} data-tip="เลือกแถวที่ต้องการแก้ไข">
                                <bs4.Col>
                                    <ReactTooltip />
                                    <bs4.Input type="checkbox" style={{ width: 23, height: 23 }}
                                        onChange={(e) => this.checkItem(e.target.checked, val.id)} />
                                </bs4.Col>
                            </td>
                            {
                                val.db_name === 'DPL' ?
                                    <td style={{ backgroundColor: '#00BFFF', color: '#000' }}>{val.db_name}</td>
                                    : val.db_name === 'DFIX' ?
                                        <td style={{ backgroundColor: '#00FA9A', color: '#000' }}>{val.db_name}</td>
                                        : val.db_name === 'DPT' ?
                                            <td style={{ backgroundColor: '#fec23e', color: '#000' }}>{val.db_name}</td>
                                            : ''
                            }
                            <td>{val.EcoResProductTranslation_LanguageId}</td>
                            <td>{val.ItemId}</td>
                            <td>{val.DisplayProductNumber}</td>
                            <td>{val.EcoResProductTranslation_Name}</td>
                            <td>{val.EcoResProductTranslation_Description}</td>
                            <td>{val.SearchName}</td>
                            <td>{val.NameAlias}</td>
                            <td>{val.DefaultOrderType}</td>
                            <td>{val.ProductType}</td>
                            <td>{val.ProductSubType}</td>
                            <td>{val.EcoResStorageDimensionGroup_Name}</td>
                            <td>{val.EcoResTrackingDimensionGroup_Name}</td>
                            <td>{val.ModelGroupId}</td>
                            <td>{val.ItemGroupId}</td>
                            <td>{val.CostGroupId}</td>
                            <td>{val.ReqGroupId}</td>
                            <td>{val.SerialNumGroupId}</td>
                            <td>{val.InventTableModuleInvent_UnitId}</td>
                            <td>{val.InventTableModuleInvent_PriceUnit}</td>
                            <td>{val.InventTableModuleInvent_PriceQty}</td>
                            <td>{val.CostModel}</td>
                            <td>{val.grossWidth}</td>
                            <td>{val.grossHeight}</td>
                            <td>{val.InventTableModulePurch_UnitId}</td>
                            <td>{val.InventTableModulePurch_PriceUnit}</td>
                            <td>{val.InventTableModulePurch_PriceQty}</td>
                            <td>{val.PurchModel}</td>
                            <td>{val.InventTableModulePurch_OverDeliveryPct}</td>
                            <td>{val.InventTableModulePurch_UnderDeliveryPct}</td>
                            <td>{val.ItemBuyerGroupId}</td>
                            <td>{val.InventTableModulePurch_TaxItemGroupId}</td>
                            <td>{val.InventTableModuleSales_UnitId}</td>
                            <td>{val.InventTableModuleSales_PriceUnit}</td>
                            <td>{val.InventTableModuleSales_PriceQty}</td>
                            <td>{val.InventTableModuleSales_TaxItemGroupId}</td>
                            <td>{val.InventTableModuleSales_LineDisc}</td>
                            <td>{val.ECL_NumberSequenceGroupProd}</td>
                            <td>{val.BOMUnitId}</td>
                            <td>{val.BOMCalcGroupId}</td>
                            <td>{val.DefaultDimension}</td>
                            <td>{val.PdsVendorCheckItem}</td>
                            <td>{val.InventSiteId}</td>
                            <td>{val.PurchInventLocationId}</td>
                            <td>{val.ItemInventLocationId}</td>
                            <td>{val.SalesInventLocationId}</td>
                            <td>{val.ECL_ItemCategoryIdG1}</td>
                            <td>{val.ECL_ItemCategoryIdG2}</td>
                            <td>{val.ECL_ItemCategoryIdG3}</td>
                            <td>{val.ECL_ItemCategoryIdG4}</td>
                            <td>{val.ECL_ItemCategoryIdBrand1}</td>
                            <td>{val.ECL_ItemCategoryIdBrand2}</td>
                            <td>{val.ECL_ItemCategoryIdBrand3}</td>
                            <td>{val.ECL_ItemCategoryIdBrand4}</td>
                            <td>{val.DPL_StatusItem}</td>
                        </tr>
                    )
                }, this)
                this.setState({ previewItem: arr, isLoading: false })
            })
    }

    checkItem = (check, id) => {
        let data = {}
        if (check === true) {
            data = {
                id: id,
            }
            let arr = this.state.arr_temp_edit.concat(data)
            this.setState({
                arr_temp_edit: arr
            }, () => {
                console.log('arr_temp_edit', this.state.arr_temp_edit)
            })
        } else {
            let arr = this.state.arr_temp_edit

            for (var i = arr.length; i--;) {
                if (arr[i].id === id) arr.splice(i, 1);
            }
            this.setState({
                arr_temp_edit: arr
            }, () => {
                console.log('arr_temp_edit', this.state.arr_temp_edit)
            })
        }
    }

    goto_edit = () => {
        this.props.history.push({
            pathname: '/Flim/EditItem',
            state: { id_edit: this.state.arr_temp_edit }
        })
    }

    Delete_item = (id) => {
        if (window.confirm("กรุณายืนยันการลบ")) {
            this.setState({ isLoading: true })
            let url = proxy.server + '/flim/delete_item'
            fetch(url, {
                method: "POST",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json;charset=utf-8"
                },
                body: JSON.stringify({
                    id: id,
                })
            })
                .then(response => response.json())
                .then((responseJson) => {
                    console.log("responseJson", responseJson)
                    if (responseJson.status === 201) {
                        this.setState({ isLoading: false }, () => {
                            alert('ลบสำเร็จ')
                            this.getItem_Preview()
                        })
                    } else {
                        this.setState({ isLoading: false }, () => {
                            alert('ไม่สามารถบันทึกข้อมูลได้ กรุณาตรวจสอบข้อมูล')
                        })
                    }
                })
        }
    }

    savetoAX = () => {
        let arr_dpl = this.state.arr_save.filter(x => x.db_name === 'DPL')
        if (arr_dpl.length === 0) {
            alert('ไม่มี Item DPL ให้ import')
        } else {
            if (window.confirm(`กรุณายืนยันการบันทึกเข้า AX DPL จำนวน ${arr_dpl.length} รายการ`)) {
                this.setState({ isLoading: true })
                let url = proxy.server + '/flim/insert_itemToAX'
                fetch(url, {
                    method: "POST",
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json;charset=utf-8"
                    },
                    body: JSON.stringify(arr_dpl)
                })
                    .then(response => response.json())
                    .then((responseJson) => {
                        console.log("responseJson", responseJson)
                        if (responseJson.status === 201) {
                            this.setState({ isLoading: false }, () => {
                                alert('บันทึกสำเร็จ')
                                this.getItem_Preview()
                            })
                        } else {
                            this.setState({ isLoading: false }, () => {
                                alert('ไม่สามารถบันทึกข้อมูลได้ กรุณาตรวจสอบข้อมูล')
                            })
                        }
                    })
            }
        }
    }

    savetoAXDPT = () => {
        let arr_dpt = this.state.arr_save.filter(x => x.db_name === 'DPT')
        if (arr_dpt.length === 0) {
            alert('ไม่มี Item DPT ให้ import')
        } else {
            if (window.confirm(`กรุณายืนยันการบันทึกเข้า AX DPT จำนวน ${arr_dpt.length} รายการ`)) {
                this.setState({ isLoading: true })
                let url = proxy.server + '/flim/dpt/insert_itemToAX'
                fetch(url, {
                    method: "POST",
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json;charset=utf-8"
                    },
                    body: JSON.stringify(arr_dpt)
                })
                    .then(response => response.json())
                    .then((responseJson) => {
                        console.log("responseJson", responseJson)
                        if (responseJson.status === 201) {
                            this.setState({ isLoading: false }, () => {
                                alert('บันทึกสำเร็จ')
                                this.getItem_Preview()
                            })
                        } else {
                            this.setState({ isLoading: false }, () => {
                                alert('ไม่สามารถบันทึกข้อมูลได้ กรุณาตรวจสอบข้อมูล')
                            })
                        }
                    })
            }
        }
    }

    render() {
        return <div>
            <Navbar nav={'Flim'} menu={'Flim_PreviewItem'} />
            <div style={{ marginLeft: 20, marginTop: 50, marginRight: 10 }}>
                <bs4.FormGroup row>
                    <bs4.Label style={{ marginLeft: 20, fontSize: '16px', fontWeight: 700 }}>ItemID</bs4.Label>
                    <bs4.Col sm='4'>
                        <Select className="col-md-12"
                            onChange={(e) => this.setState({ itemID: e.value })}
                            options={this.state.option_itemID}
                            placeholder={'ค้นหา ItemID'}
                        />
                    </bs4.Col>
                    <bs4.Label style={{ marginLeft: 20, fontSize: '16px', fontWeight: 700 }}>Description</bs4.Label>
                    <bs4.Col sm='4'>
                        <Select className="col-md-12"
                            onChange={(e) => this.setState({ description: e.value })}
                            options={this.state.option_description}
                            placeholder={'ค้นหา Description'}
                        />
                    </bs4.Col>
                </bs4.FormGroup>
                <bs4.FormGroup row>
                    <bs4.Label style={{ marginLeft: 20, fontSize: '16px', fontWeight: 700 }}>ItemG3</bs4.Label>
                    <bs4.Col sm='4'>
                        <Select className="col-md-12"
                            onChange={(e) => this.setState({ itemG3: e.value })}
                            options={this.state.option_itemG3}
                            placeholder={'ค้นหา ItemG3'}
                        />
                    </bs4.Col>
                    <bs4.Label style={{ marginLeft: 20, fontSize: '16px', fontWeight: 700 }}>Ibrand3</bs4.Label>
                    <bs4.Col sm='4'>
                        <Select className="col-md-12"
                            onChange={(e) => this.setState({ ibrand3: e.value })}
                            options={this.state.option_ibrand3}
                            placeholder={'ค้นหา Ibrand3'}
                        />
                    </bs4.Col>
                    <bs4.Button outline color="success" style={{ fontSize: 16, fontWeight: 500, marginRight: 20, width: 150 }} onClick={() => this.previewItem()}>SEARCH</bs4.Button>
                    <bs4.Button outline style={{ fontSize: 16, fontWeight: 500, marginRight: 20, width: 150 }} onClick={() => this.allData_Preveiw()}>ดูข้อมูลทั้งหมด</bs4.Button>
                </bs4.FormGroup>
                <bs4.FormGroup row style={{ marginLeft: 20, marginBottom: 20 }}>
                    <bs4.Col sm='4'>
                        <bs4.Input type='select' onChange={(e) => e.target.value === '' ? this.allData_Preveiw() : this.setState({ value_serach: e.target.value }, () => { this.previewItem() })}>
                            <option value=''>CREATED</option>
                            <option value='IMPORTED'>IMPORTED</option>
                        </bs4.Input>
                    </bs4.Col>
                    {
                        this.state.value_serach !== 'IMPORTED'
                            ? this.state.onPage === 'Preview'
                                ? <div>
                                    <bs4.Button color="warning" style={{ fontSize: 16, fontWeight: 500, marginRight: 20, width: 150 }} onClick={() => this.getItem_Edit()}>EDIT</bs4.Button>
                                    <bs4.Button color="primary" style={{ fontSize: 16, fontWeight: 500, width: 150, marginRight: 20 }} onClick={() => this.savetoAX()}>IMPORT TO DPL</bs4.Button>
                                    <bs4.Button color="success" style={{ fontSize: 16, fontWeight: 500, width: 150, marginRight: 20 }} onClick={() => this.savetoAXDPT()}>IMPORT TO DPT</bs4.Button>
                                    <Workbook filename={this.state.filename + '.xlsx'} element={<bs4.Button outline color="success" style={{ fontSize: 16, fontWeight: 500, marginRight: 20, width: 150 }}>EXPORT EXCEL</bs4.Button>} >
                                        <Workbook.Sheet data={this.state.arrDataExcel} name="sheet1">
                                            <Workbook.Column label="db_name" value="db_name" />
                                            <Workbook.Column label="EcoResProductTranslation_LanguageId" value="EcoResProductTranslation_LanguageId" />
                                            <Workbook.Column label="ItemId" value="ItemId" />
                                            <Workbook.Column label="DisplayProductNumber" value="DisplayProductNumber" />
                                            <Workbook.Column label="EcoResProductTranslation_Name" value="EcoResProductTranslation_Name" />
                                            <Workbook.Column label="EcoResProductTranslation_Description" value="EcoResProductTranslation_Description" />
                                            <Workbook.Column label="SearchName" value="SearchName" />
                                            <Workbook.Column label="NameAlias" value="NameAlias" />
                                            <Workbook.Column label="DefaultOrderType" value="DefaultOrderType" />
                                            <Workbook.Column label="ProductType" value="ProductType" />
                                            <Workbook.Column label="ProductSubType" value="ProductSubType" />
                                            <Workbook.Column label="EcoResStorageDimensionGroup_Name" value="EcoResStorageDimensionGroup_Name" />
                                            <Workbook.Column label="EcoResTrackingDimensionGroup_Name" value="EcoResTrackingDimensionGroup_Name" />
                                            <Workbook.Column label="ModelGroupId" value="ModelGroupId" />
                                            <Workbook.Column label="ItemGroupId" value="ItemGroupId" />
                                            <Workbook.Column label="CostGroupId" value="CostGroupId" />
                                            <Workbook.Column label="ReqGroupId" value="ReqGroupId" />
                                            <Workbook.Column label="SerialNumGroupId" value="SerialNumGroupId" />
                                            <Workbook.Column label="InventTableModuleInvent_UnitId" value="InventTableModuleInvent_UnitId" />
                                            <Workbook.Column label="InventTableModuleInvent_PriceUnit" value="InventTableModuleInvent_PriceUnit" />
                                            <Workbook.Column label="InventTableModuleInvent_PriceQty" value="InventTableModuleInvent_PriceQty" />
                                            <Workbook.Column label="CostModel" value="CostModel" />
                                            <Workbook.Column label="grossWidth" value="grossWidth" />
                                            <Workbook.Column label="grossHeight" value="grossHeight" />
                                            <Workbook.Column label="InventTableModulePurch_UnitId" value="InventTableModulePurch_UnitId" />
                                            <Workbook.Column label="InventTableModulePurch_PriceUnit" value="InventTableModulePurch_PriceUnit" />
                                            <Workbook.Column label="InventTableModulePurch_PriceQty" value="InventTableModulePurch_PriceQty" />
                                            <Workbook.Column label="PurchModel" value="PurchModel" />
                                            <Workbook.Column label="InventTableModulePurch_OverDeliveryPct" value="InventTableModulePurch_OverDeliveryPct" />
                                            <Workbook.Column label="InventTableModulePurch_UnderDeliveryPct" value="InventTableModulePurch_UnderDeliveryPct" />
                                            <Workbook.Column label="ItemBuyerGroupId" value="ItemBuyerGroupId" />
                                            <Workbook.Column label="InventTableModulePurch_TaxItemGroupId" value="InventTableModulePurch_TaxItemGroupId" />
                                            <Workbook.Column label="InventTableModuleSales_UnitId" value="InventTableModuleSales_UnitId" />
                                            <Workbook.Column label="InventTableModuleSales_PriceUnit" value="InventTableModuleSales_PriceUnit" />
                                            <Workbook.Column label="InventTableModuleSales_PriceQty" value="InventTableModuleSales_PriceQty" />
                                            <Workbook.Column label="InventTableModuleSales_TaxItemGroupId" value="InventTableModuleSales_TaxItemGroupId" />
                                            <Workbook.Column label="InventTableModuleSales_LineDisc" value="InventTableModuleSales_LineDisc" />
                                            <Workbook.Column label="ECL_NumberSequenceGroupProd" value="ECL_NumberSequenceGroupProd" />
                                            <Workbook.Column label="BOMUnitId" value="BOMUnitId" />
                                            <Workbook.Column label="BOMCalcGroupId" value="BOMCalcGroupId" />
                                            <Workbook.Column label="DefaultDimension" value="DefaultDimension" />
                                            <Workbook.Column label="PdsVendorCheckItem" value="PdsVendorCheckItem" />
                                            <Workbook.Column label="InventSiteId" value="InventSiteId" />
                                            <Workbook.Column label="PurchInventLocationId" value="PurchInventLocationId" />
                                            <Workbook.Column label="ItemInventLocationId" value="ItemInventLocationId" />
                                            <Workbook.Column label="SalesInventLocationId" value="SalesInventLocationId" />
                                            <Workbook.Column label="ECL_ItemCategoryIdG1" value="ECL_ItemCategoryIdG1" />
                                            <Workbook.Column label="ECL_ItemCategoryIdG2" value="ECL_ItemCategoryIdG2" />
                                            <Workbook.Column label="ECL_ItemCategoryIdG3" value="ECL_ItemCategoryIdG3" />
                                            <Workbook.Column label="ECL_ItemCategoryIdG4" value="ECL_ItemCategoryIdG4" />
                                            <Workbook.Column label="ECL_ItemCategoryIdBrand1" value="ECL_ItemCategoryIdBrand1" />
                                            <Workbook.Column label="ECL_ItemCategoryIdBrand2" value="ECL_ItemCategoryIdBrand2" />
                                            <Workbook.Column label="ECL_ItemCategoryIdBrand3" value="ECL_ItemCategoryIdBrand3" />
                                            <Workbook.Column label="ECL_ItemCategoryIdBrand4" value="ECL_ItemCategoryIdBrand4" />
                                            <Workbook.Column label="DPL_StatusItem" value="DPL_StatusItem" />
                                        </Workbook.Sheet>
                                    </Workbook>
                                </div>
                                : <div>
                                    <bs4.Button color="success" style={{ fontSize: 16, fontWeight: 500, marginRight: 20, width: 150 }} onClick={() => this.goto_edit()}>GO TO EDIT</bs4.Button>
                                    <bs4.Button outline color="warning" style={{ fontSize: 16, fontWeight: 500, width: 150, marginRight: 20 }} onClick={() => this.getItem_Preview()}>CANCEL</bs4.Button>
                                </div>
                            : ''
                    }
                    <ScaleLoader
                        size={15}
                        loading={this.state.isLoading}
                    />
                    <ScaleLoader
                        size={15}
                        loading={this.state.isLoading}
                    />
                    <ScaleLoader
                        size={15}
                        loading={this.state.isLoading}
                    />
                </bs4.FormGroup>
                <bs4.Table bordered hover style={{ fontSize: 15 }}>
                    <thead style={{ backgroundColor: '#E8DCCD', color: '#000' }}>
                        <tr style={{ textAlign: 'center' }}>
                            <th style={{ backgroundColor: '#fff' }}></th>
                            <th>ฐานข้อมูล</th>
                            <th>EcoRes<br />Product<br />Translation_<br />LanguageId</th>
                            <th>ItemId</th>
                            <th style={{ backgroundColor: '#61ba52' }}>Display<br />Product<br />Number</th>
                            <th style={{ backgroundColor: '#61ba52' }}>EcoRes<br />ProductTranslation<br />_Name</th>
                            <th>EcoRes<br />ProductTranslation<br />_Description</th>
                            <th>SearchName</th>
                            <th>NameAlias</th>
                            <th>Default<br />OrderType</th>
                            <th>Product<br />Type</th>
                            <th>Product<br />SubType</th>
                            <th>EcoRes<br />Storage<br />Dimension<br />Group_Name</th>
                            <th>EcoRes<br />Tracking<br />Dimension<br />Group_Name</th>
                            <th>Model<br />GroupId</th>
                            <th>Item<br />GroupId</th>
                            <th>Cost<br />GroupId</th>
                            <th>Req<br />GroupId</th>
                            <th>SerialNum<br />GroupId</th>
                            <th>Invent<br />TableModule<br />Invent_<br />UnitId</th>
                            <th>Invent<br />TableModule<br />Invent_<br />PriceUnit</th>
                            <th>Invent<br />TableModule<br />Invent_<br />PriceQty</th>
                            <th>CostModel</th>
                            <th>grossWidth</th>
                            <th>grossHeight</th>
                            <th>Invent<br />Table<br />ModulePurch_<br />UnitId</th>
                            <th>Invent<br />Table<br />ModulePurch_<br />PriceUnit</th>
                            <th>Invent<br />Table<br />ModulePurch_<br />PriceQty</th>
                            <th>Purch<br />Model</th>
                            <th>Invent<br />Table<br />ModulePurch_<br />Over<br />DeliveryPct</th>
                            <th>Invent<br />Table<br />ModulePurch_<br />Under<br />DeliveryPct</th>
                            <th>ItemBuyer<br />GroupId</th>
                            <th>Invent<br />Table<br />ModulePurch_<br />TaxItemGroupId</th>
                            <th>Invent<br />Table<br />ModuleSales_<br />UnitId</th>
                            <th>Invent<br />Table<br />ModuleSales_<br />PriceUnit</th>
                            <th>Invent<br />Table<br />ModuleSales_<br />PriceQty</th>
                            <th>Invent<br />Table<br />ModuleSales_<br />TaxItemGroupId</th>
                            <th>Invent<br />Table<br />ModuleSales_<br />LineDisc</th>
                            <th>ECL_Number<br />Sequence<br />GroupProd</th>
                            <th>BOMUnitId</th>
                            <th>BOMCalc<br />GroupId</th>
                            <th>Default<br />Dimension</th>
                            <th>PdsVendor<br />CheckItem</th>
                            <th>Invent<br />SiteId</th>
                            <th>Purch<br />Invent<br />LocationId</th>
                            <th>Item<br />Invent<br />LocationId</th>
                            <th>Sales<br />Invent<br />LocationId</th>
                            <th>ECL_Item<br />Category<br />IdG1</th>
                            <th>ECL_Item<br />Category<br />IdG2</th>
                            <th>ECL_Item<br />Category<br />IdG3</th>
                            <th>ECL_Item<br />Category<br />IdG4</th>
                            <th>ECL_Item<br />Category<br />IdBrand1</th>
                            <th>ECL_Item<br />Category<br />IdBrand2</th>
                            <th>ECL_Item<br />Category<br />IdBrand3</th>
                            <th>ECL_Item<br />Category<br />IdBrand4</th>
                            <th>DPL_<br />Status<br />Item</th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.state.previewItem}
                    </tbody>
                </bs4.Table>
            </div>
        </div>
    }
}

export default Flim_PreviewItem